import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingAiAvatarGeneratorConfig } from '@/data/landingConfig/landingAiAvatarGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_AiAvatarGenerator } from './schemaObject';

interface Props {}
const AiAvatarGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_AiAvatarGenerator} />
			<LandingTemplate
				data={landingAiAvatarGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelHeadshotGenerator()}
			/>
		</>
	);
};

export default AiAvatarGenerator;
